import { Icons } from "@/components/ui/icons";
import type { LiquidRailItem } from "@/workshop/components/canvas/liquid-glass-rail";

export const LIQUID_NAV_ITEMS: LiquidRailItem[] = [
  { id: "home", label: "Home", icon: Icons.LayoutGrid, section: "primary" },
  { id: "frames", label: "Frames", icon: Icons.Layers, section: "primary" },
  { id: "browse", label: "Browse", icon: Icons.FolderTree, section: "primary" },
  { id: "search", label: "Search", icon: Icons.Search, section: "utility" },
  { id: "settings", label: "Settings", icon: Icons.Settings, section: "utility" },
];

export const LIQUID_CANVAS_ITEMS: LiquidRailItem[] = [
  { id: "fit", label: "Fit view", icon: Icons.Maximize, section: "primary" },
  { id: "zoom-in", label: "Zoom in", icon: Icons.ZoomIn, section: "primary" },
  { id: "zoom-out", label: "Zoom out", icon: Icons.ZoomOut, section: "primary" },
  { id: "pan", label: "Pan", icon: Icons.Hand, section: "actions" },
  { id: "focus", label: "Focus", icon: Icons.Target, section: "actions" },
  { id: "note", label: "Note", icon: Icons.StickyNote, section: "utility" },
  { id: "board", label: "Board", icon: Icons.Kanban, section: "utility" },
];
